type EnvironmentType = 'localhost' | 'development' | 'staging' | 'production' | any;
let environment: EnvironmentType = null
// environment = 'localhost';
// environment = 'development';
// environment = 'staging';
// environment = 'production';
environment = process.env.REACT_APP_ENV || 'development'

export const RE_CAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY

export default environment
